import script from "./api.vue?vue&type=script&setup=true&lang=js"
export * from "./api.vue?vue&type=script&setup=true&lang=js"

import "./api.vue?vue&type=style&index=0&id=7e2482ad&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2482ad"]])

export default __exports__